export const ACCESS_TOKEN = "pnuh-spine-health-access-token";
export const REFRESH_TOKEN = "pnuh-spine-health-refresh-token";
export const RECOIL_PERSIST_KEY = "pnuh-spine-health-recoil-persist";
export const RECOIL_PERSIST_LOGIN_KEY =
  "pnuh-spine-health-recoil-persist-login";
